import React from 'react'

export default function Back({ className, color }) {
    return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_0_981)">
            <rect x="5" y="4" width="32" height="32" rx="10" stroke="#6E6E83" strokeWidth="2.5" />
            <path d="M26 11L16 20L26 29" stroke="#6E6E83" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <filter id="filter0_d_0_981" x="0.75" y="0.75" width="40.5" height="40.5" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.376471 0 0 0 0 0.423529 0 0 0 0 0.501961 0 0 0 0.05 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_981" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_981" result="shape" />
            </filter>
        </defs>
    </svg>
      

    )
}
